<div class="flex gap-4 w-full h-full pb-6">
  <div class="flex flex-col gap-2 w-full">
    <!-- <div class="flex-col flex gap-4 pb-2 w-full">
      <span class="text-[24px]">Customer</span>
      <div class="flex gap-6">
        <span>menu</span>
        <span>Customer</span>
      </div>
    </div> -->
    <div class="flex gap-6 h-full w-full">
      <div class="w-80 overflow-clip bg-white h-full rounded-t-xl">
        <div class="flex flex-col">
          <button
            *ngFor="let item of subMenuItems"
            [routerLink]="'/home/customer/' + item.route"
            routerLinkActive="bg-primary text-white"
            #rla="routerLinkActive"
            class="p-5 items-center flex justify-between"
            [ngStyle]="{
              'display':item.hidden && !rla.isActive ? 'none' : undefined,
            }"
          >
            <div class="flex items-center gap-2">
              <span>{{ item.name }}</span>
            </div>
            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="inherit"
              class="stroke-white fill-none"
              routerLinkActive="stroke-white"
            >
              <path
                d="M6.79083 13.0302L10.8597 8.9613L6.79083 4.8924"
                stroke="inherit"
                stroke-width="1.3563"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="w-full overflow-y-auto h-full pb-20">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
